var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJersey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.655,102.276H.345A.357.357,0,0,1,0,101.908V88.644a.357.357,0,0,1,.345-.368h19.31a.357.357,0,0,1,.345.368v13.263A.357.357,0,0,1,19.655,102.276Z",
    transform: "translate(0 -88.276)",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,88.644a.357.357,0,0,0-.345-.368h-.914L10,94.4,1.258,88.276H.345A.357.357,0,0,0,0,88.644v.512l8.742,6.119L0,101.4v.512a.357.357,0,0,0,.345.368h.914L10,96.157l8.742,6.119h.914a.357.357,0,0,0,.345-.368V101.4l-8.742-6.119L20,89.157Z",
    transform: "translate(0 -88.276)",
    fill: "#ff4b55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.114,109.493a.218.218,0,0,0-.309-.062s.214.154.069.317a.221.221,0,0,1-.377-.119.108.108,0,1,0-.046-.006c-.027.105-.3.186-.382.011a.23.23,0,0,1,.243-.34s-.037-.243-.3-.141a.238.238,0,1,0-.154,0c-.259-.1-.3.141-.3.141a.23.23,0,0,1,.243.34c-.08.174-.356.094-.382-.011a.109.109,0,1,0-.046.006.221.221,0,0,1-.377.119c-.145-.162.069-.317.069-.317a.218.218,0,0,0-.309.062.249.249,0,0,0-.309-.185,3.424,3.424,0,0,1,.429.946h2.107a3.423,3.423,0,0,1,.429-.946A.25.25,0,0,0,225.114,109.493Z",
    transform: "translate(-213.941 -107.788)",
    fill: "#ffe15a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231.761,140.174a3.17,3.17,0,0,0-2.107,0c-.553,2.421,1.054,3.068,1.054,3.068S232.313,142.6,231.761,140.174Z",
    transform: "translate(-220.707 -137.871)",
    fill: "#ff4b55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.04 2.584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.486,162.442a.126.126,0,0,0-.095.026s-.015-.061.064-.076S236.486,162.442,236.486,162.442Z",
    transform: "translate(-236.284 -161.86)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.114,160.434a.126.126,0,0,0-.1-.022s.015-.061.092-.036S235.114,160.434,235.114,160.434Z",
    transform: "translate(-234.972 -159.928)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.665,161.414a.148.148,0,0,0-.1.026s-.017-.061.07-.076S235.665,161.414,235.665,161.414Z",
    transform: "translate(-235.491 -160.876)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.637,165.125a.126.126,0,0,0-.086.047s-.029-.056.045-.088S257.637,165.125,257.637,165.125Z",
    transform: "translate(-256.504 -164.426)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.792,163.475a.126.126,0,0,0-.1,0s0-.063.081-.057S255.792,163.475,255.792,163.475Z",
    transform: "translate(-254.735 -162.843)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.6,164.268a.148.148,0,0,0-.095.049s-.03-.055.05-.09S256.6,164.268,256.6,164.268Z",
    transform: "translate(-255.507 -163.607)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.68,165.716s-.019,0-.054.032c0,0-.025-.055.048-.082S271.68,165.716,271.68,165.716Z",
    transform: "translate(-269.96 -164.985)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.054,163.987a.121.121,0,0,0-.094-.005s0-.06.081-.05S270.054,163.987,270.054,163.987Z",
    transform: "translate(-268.37 -163.332)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.764,164.824a.142.142,0,0,0-.094.042s-.026-.055.054-.083S270.764,164.824,270.764,164.824Z",
    transform: "translate(-269.045 -164.14)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.362,153.49a.137.137,0,0,0-.105-.015s.011-.067.1-.048S234.362,153.49,234.362,153.49Z",
    transform: "translate(-234.245 -153.29)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.52,150.467a.125.125,0,0,0-.094-.051.077.077,0,0,1,.114-.015C234.613,150.45,234.52,150.467,234.52,150.467Z",
    transform: "translate(-234.407 -150.382)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1,152.1a.154.154,0,0,0-.114-.023s.015-.071.106-.045S234.1,152.1,234.1,152.1Z",
    transform: "translate(-233.986 -151.957)",
    fill: "#82afff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.52,149.961c.081,0,.178-.03.194-.114s-.065-.146-.177-.142a4.155,4.155,0,0,1-.435.045c-.146-.005-.15-.15.071-.134.328.023.38-.02.38-.02-.176.033-.247-.029-.434-.029s-.223.13-.147.2.392.026.473.011.185-.016.193.041-.129.049-.226.045c-.154-.006-.378.036-.577.046-.166.009-.189-.038-.227-.086a.1.1,0,0,0,.01-.08.136.136,0,0,0,.032-.071.137.137,0,0,0-.075.009.161.161,0,0,0-.195,0,.138.138,0,0,0-.075-.009.137.137,0,0,0,.032.071.106.106,0,0,0,0,.028.115.115,0,0,0,.043.088.073.073,0,0,1,.026.042l0,.023a.034.034,0,0,0,.017.023.312.312,0,0,1-.235-.148c-.038-.054-.061-.173-.118-.186l-.034.18a.532.532,0,0,0,.207.236,2,2,0,0,0,.23.1c.006.026-.094.043-.2.022-.071-.014-.166-.117-.22-.11l.063.14a.6.6,0,0,0,.451.088.162.162,0,0,0,.132-.122c.037-.007.078-.015.2-.045a.928.928,0,0,1,.173-.023c.017.039.056.088.189.093,0,0,.032.051-.078.041s-.138-.045-.2-.037l.058.137a.814.814,0,0,1,.314-.031.049.049,0,0,0,.051-.019c.019-.028.01-.044-.007-.069a.287.287,0,0,1-.019-.1c.063.016.258-.024.328-.018a.083.083,0,0,1,.065.116c-.016.028-.164,0-.164,0l.05.135a.27.27,0,0,0,.052-.043c.031-.029.156-.019.156-.041V150a.02.02,0,0,0-.022-.02C237.576,150.007,237.52,149.961,237.52,149.961Z",
    transform: "translate(-226.925 -147.017)",
    fill: "#ffe15a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.679,156.469a.094.094,0,0,1,.009.026l0,.023a.016.016,0,0,0,.015.014h.064a.016.016,0,0,0,.015-.014l0-.023a.093.093,0,0,1,.009-.026Z",
    transform: "translate(-235.128 -153.624)",
    fill: "#ff4b55"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.215 2.874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.51,157.518c-.015,0-.026,0-.025.022l.006.088c0,.013.009.024.019.024s.018-.01.019-.024l.006-.088C245.536,157.52,245.524,157.518,245.51,157.518Z",
    transform: "translate(-245.154 -157.518)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.044,182.253a.1.1,0,0,0-.077.021s-.013-.05.052-.062S240.044,182.253,240.044,182.253Z",
    transform: "translate(-239.879 -181.119)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.924,180.615a.1.1,0,0,0-.078-.018s.012-.05.075-.03S238.924,180.615,238.924,180.615Z",
    transform: "translate(-238.809 -179.544)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.375,181.414a.121.121,0,0,0-.084.021s-.014-.05.057-.062S239.375,181.414,239.375,181.414Z",
    transform: "translate(-239.233 -180.317)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.3,184.443a.1.1,0,0,0-.07.038s-.024-.045.036-.072S257.3,184.443,257.3,184.443Z",
    transform: "translate(-256.372 -183.214)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.792,183.1a.1.1,0,0,0-.08,0s0-.051.066-.046S255.792,183.1,255.792,183.1Z",
    transform: "translate(-254.93 -181.923)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.451,183.744a.121.121,0,0,0-.077.04s-.025-.045.041-.073S256.451,183.744,256.451,183.744Z",
    transform: "translate(-255.558 -182.546)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.75,184.924s-.016,0-.044.026c0,0-.02-.045.039-.067S268.75,184.924,268.75,184.924Z",
    transform: "translate(-267.347 -183.67)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.425,183.515a.1.1,0,0,0-.077,0s0-.049.066-.041S267.425,183.515,267.425,183.515Z",
    transform: "translate(-266.051 -182.323)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,184.2a.116.116,0,0,0-.077.034s-.021-.045.044-.068S268,184.2,268,184.2Z",
    transform: "translate(-266.601 -182.98)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.311,174.952a.112.112,0,0,0-.086-.012s.009-.055.078-.039S238.311,174.952,238.311,174.952Z",
    transform: "translate(-238.215 -174.13)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.441,172.485a.1.1,0,0,0-.077-.042.063.063,0,0,1,.093-.012C238.517,172.471,238.441,172.485,238.441,172.485Z",
    transform: "translate(-238.348 -171.758)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1,173.821A.125.125,0,0,0,238,173.8s.012-.058.087-.036S238.1,173.821,238.1,173.821Z",
    transform: "translate(-238.005 -173.044)",
    fill: "#82afff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M240.882,172.075c.066,0,.145-.025.158-.093s-.053-.119-.144-.116a3.391,3.391,0,0,1-.355.036c-.119,0-.122-.122.058-.11.268.019.31-.016.31-.016-.144.027-.2-.023-.354-.023s-.182.106-.12.163.32.022.386.009.151-.013.157.034-.105.04-.184.037c-.126,0-.308.029-.471.038-.135.007-.154-.031-.185-.07a.088.088,0,0,0,.011-.043.086.086,0,0,0,0-.022.036.036,0,1,0-.035-.051.131.131,0,0,0-.159,0,.112.112,0,0,0-.061-.007.111.111,0,0,0,.026.058.086.086,0,0,0,0,.022.094.094,0,0,0,.035.072.06.06,0,0,1,.021.034l0,.019a.028.028,0,0,0,.014.019.255.255,0,0,1-.191-.121c-.031-.044-.05-.141-.1-.152l-.028.147a.434.434,0,0,0,.169.192,1.624,1.624,0,0,0,.188.083c0,.022-.077.035-.159.018-.058-.012-.135-.1-.18-.089l.052.115a.488.488,0,0,0,.368.072.132.132,0,0,0,.107-.1c.03-.006.063-.012.166-.037a.755.755,0,0,1,.141-.018c.014.032.046.072.154.076,0,0,.026.042-.063.033s-.113-.036-.166-.03l.047.112a.664.664,0,0,1,.256-.025.04.04,0,0,0,.042-.016c.016-.023.008-.036-.006-.056a.234.234,0,0,1-.015-.079c.052.013.211-.019.268-.014a.068.068,0,0,1,.053.095c-.013.023-.133,0-.133,0l.04.11a.22.22,0,0,0,.043-.035c.025-.023.127-.016.127-.033v-.2a.017.017,0,0,0-.018-.016C240.928,172.113,240.882,172.075,240.882,172.075Z",
    transform: "translate(-230.398 -168.279)",
    fill: "#ffe15a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M246.727,177.381a.074.074,0,0,1,.007.021l0,.019a.013.013,0,0,0,.013.012h.052a.013.013,0,0,0,.013-.012l0-.019a.078.078,0,0,1,.007-.021Z",
    transform: "translate(-237.095 -173.663)",
    fill: "#ff4b55"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.41 3.738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.4,178.238c-.012,0-.021,0-.02.018l0,.072c0,.011.007.019.015.019s.014-.008.015-.019l0-.072C247.425,178.239,247.416,178.238,247.4,178.238Z",
    transform: "translate(-247.166 -178.238)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,198.066a.077.077,0,0,0-.058.016s-.009-.037.039-.046S244,198.066,244,198.066Z",
    transform: "translate(-243.876 -197.159)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.161,196.838a.077.077,0,0,0-.058-.014s.009-.037.056-.022S243.161,196.838,243.161,196.838Z",
    transform: "translate(-243.075 -195.979)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.5,197.437a.09.09,0,0,0-.063.016s-.01-.037.043-.046S243.5,197.437,243.5,197.437Z",
    transform: "translate(-243.392 -196.558)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.917,199.706a.077.077,0,0,0-.053.029s-.018-.034.027-.054S256.917,199.706,256.917,199.706Z",
    transform: "translate(-256.225 -198.728)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.791,198.7a.077.077,0,0,0-.06,0s0-.038.049-.035S255.791,198.7,255.791,198.7Z",
    transform: "translate(-255.145 -197.761)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.285,199.182a.091.091,0,0,0-.058.03s-.019-.034.031-.055S256.285,199.182,256.285,199.182Z",
    transform: "translate(-255.616 -198.228)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.494,200.066s-.012,0-.033.02c0,0-.015-.034.029-.05S265.494,200.066,265.494,200.066Z",
    transform: "translate(-264.443 -199.069)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5,199.01a.074.074,0,0,0-.058,0s0-.037.05-.03S264.5,199.01,264.5,199.01Z",
    transform: "translate(-263.473 -198.059)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.933,199.521a.087.087,0,0,0-.057.025s-.016-.034.033-.051S264.933,199.521,264.933,199.521Z",
    transform: "translate(-263.884 -198.553)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.7,192.6a.084.084,0,0,0-.064-.009s.006-.041.059-.029S242.7,192.6,242.7,192.6Z",
    transform: "translate(-242.631 -191.927)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.8,190.752a.076.076,0,0,0-.057-.031.047.047,0,0,1,.07-.009C242.856,190.742,242.8,190.752,242.8,190.752Z",
    transform: "translate(-242.73 -190.15)",
    fill: "#82afff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.542,191.753a.094.094,0,0,0-.07-.014s.009-.043.065-.027S242.542,191.753,242.542,191.753Z",
    transform: "translate(-242.472 -191.113)",
    fill: "#82afff"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M244.628,190.444c.05,0,.109-.018.118-.07s-.04-.089-.108-.087a2.542,2.542,0,0,1-.266.027c-.089,0-.092-.091.043-.082.2.014.232-.012.232-.012-.108.02-.151-.018-.265-.018s-.136.079-.09.122.239.016.289.007.113-.01.118.025-.079.03-.138.027c-.094,0-.231.022-.352.028-.1.005-.116-.023-.139-.053a.066.066,0,0,0,.008-.032.065.065,0,0,0,0-.017.084.084,0,0,0,.019-.044.084.084,0,0,0-.046.005.1.1,0,0,0-.119,0,.027.027,0,1,0-.026.038.064.064,0,0,0,0,.017.071.071,0,0,0,.027.054.044.044,0,0,1,.016.025l0,.014a.021.021,0,0,0,.01.014.191.191,0,0,1-.143-.09c-.023-.033-.037-.106-.072-.114l-.021.11a.325.325,0,0,0,.126.144,1.213,1.213,0,0,0,.141.062c0,.016-.057.026-.119.013-.043-.009-.1-.072-.134-.067l.039.086a.365.365,0,0,0,.275.054.1.1,0,0,0,.08-.074c.023,0,.047-.009.124-.028a.56.56,0,0,1,.106-.014c.01.024.034.054.116.057,0,0,.02.031-.048.025s-.084-.027-.124-.023l.035.084a.5.5,0,0,1,.192-.019.03.03,0,0,0,.031-.012c.012-.017.006-.027,0-.042a.174.174,0,0,1-.011-.059c.039.01.158-.014.2-.011a.051.051,0,0,1,.039.071c-.01.017-.1,0-.1,0l.03.083a.166.166,0,0,0,.032-.026c.019-.018.1-.012.1-.025v-.153a.012.012,0,0,0-.014-.012C244.662,190.472,244.628,190.444,244.628,190.444Z",
    transform: "translate(-234.268 -185.957)",
    fill: "#ffe15a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M249,194.419a.058.058,0,0,1,.005.016l0,.014a.01.01,0,0,0,.009.009h.039a.01.01,0,0,0,.009-.009l0-.014a.058.058,0,0,1,.005-.016Z",
    transform: "translate(-239.281 -189.99)",
    fill: "#ff4b55"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M249.509,195.06c-.009,0-.016,0-.015.014l0,.054c0,.008.006.014.011.014s.011-.006.011-.014l0-.054C249.525,195.061,249.518,195.06,249.509,195.06Z",
    transform: "translate(-239.75 -190.605)",
    fill: "#82afff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJersey);
export default __webpack_public_path__ + "static/media/jersey.ea9786600f4c3885942b5174165b0f53.svg";
export { ForwardRef as ReactComponent };